import { useState, useEffect } from "react";
import { api } from "../api/client";
import { Spinner, FormGroup } from "../components/UI";

export default function Amtsperioden() {
  const [amtsperioden, setAmtsperioden] = useState(null);
  const [neueBezeichnung, setNeueBezeichnung] = useState("");
  const [neuerBeginn, setNeuerBeginn] = useState("");

  const laden = () => api.getAmtsperioden().then(setAmtsperioden);
  useEffect(() => { laden(); }, []);

  if (!amtsperioden) return <Spinner />;

  const anlegen = async () => {
    if (!neueBezeichnung.trim() || !neuerBeginn) return;
    await api.createAmtsperiode({ bezeichnung: neueBezeichnung.trim(), beginn: new Date(neuerBeginn).toISOString() });
    setNeueBezeichnung(""); setNeuerBeginn("");
    laden();
  };

  return (
    <div>
      <div className="page-header">
        <div><div className="breadcrumb">Verwaltung</div><h2>Amtsperioden</h2></div>
      </div>
      <div className="content" style={{ maxWidth: 600 }}>
        <div className="card" style={{ marginBottom: 16 }}>
          <div className="card-header"><h3>Amtsperioden</h3></div>
          <table className="table">
            <thead><tr><th>Bezeichnung</th><th>Beginn</th></tr></thead>
            <tbody>
              {amtsperioden.map(a => (
                <tr key={a.id}><td>{a.bezeichnung}</td><td>{new Date(a.beginn).toLocaleDateString("de-DE")}</td></tr>
              ))}
              {amtsperioden.length === 0 && (
                <tr><td colSpan={2} style={{ textAlign: "center", color: "var(--ink-faint)", padding: 20 }}>Keine Amtsperioden.</td></tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="card">
          <div className="card-header"><h3>Neue Amtsperiode</h3></div>
          <div className="card-body">
            <FormGroup label="Bezeichnung">
              <input className="form-control" placeholder="z.B. Wehrleitung 2026–2032" value={neueBezeichnung} onChange={e => setNeueBezeichnung(e.target.value)} />
            </FormGroup>
            <FormGroup label="Beginn">
              <input className="form-control" type="date" value={neuerBeginn} onChange={e => setNeuerBeginn(e.target.value)} />
            </FormGroup>
            <button className="btn btn-primary" onClick={anlegen}>Anlegen</button>
          </div>
        </div>
      </div>
    </div>
  );
}
